/**
 * SEMILLA del canon F6 (hoy.html) para lo que la API aún no sirve. Cada
 * valor se sustituye por el endpoint real cuando exista (M1: «pantallas
 * sobre datos semilla, aún sin motor completo detrás»).
 */
export const HOY_SEED = {
  slaVencidos: 1,
  actosRegistro: 38,
  desde: "06:30",
  cola: { pendientes: 7, slaVencido: "1", slaDetalle: "SLA vencido (activación Vielsa)", esperaMedia: "1 h 40 m" },
  aMedias: {
    hoy: { t: "hoy 09:15", slug: "erosion-margen", version: "draft v2", texto: "con la pregunta de los rappels — listo para publicar con rito" },
    ayer: { drafts: ["inversion-capex", "salud-financiera"], menor: "morosidad-cobros" },
    biblioteca: { borradoresSinFuente: 2 },
  },
  casas: [
    { estado: "parada", nombre: "Bodegues Roure", detalle: "sin actividad hace 16 días" },
    { estado: "parada", nombre: "Congelados Mir", detalle: "sin actividad hace 21 días" },
    { estado: "onboarding", nombre: "Textil Bages", detalle: "4 criterios propuestos aguardan el «sí» de su executive" },
  ] as const,
  pulso: { actos: 38, respuestasConTraza: 25, toquesMemoria: 6 },
} as const;
